export const searchColumn = (ctx) => {
  return [
    {
      name: '银行类别',
      prop: 'bankName',
      type: 'input',
    },
    {
      name: '分行',
      prop: 'branchName',
      type: 'input',
    },
    {
      name: '省',
      prop: 'bankCity',
      type: 'select',
      changeMethod: 'changeMethod',
      options: ctx.provinceList,
    },
    {
      name: '市',
      prop: 'bankRegion',
      type: 'select',
      options: ctx.cityList,
    },
    {
      name: '银行行号',
      prop: 'bankUnionNumber',
      type: 'input',
    },
  ];
};

export const column = () => {
  return [
    {
      prop: 'bankCode',
      label: '银行代码',
    },
    {
      prop: 'bankName',
      label: '银行类别',
    },
    {
      prop: 'branchName',
      label: '分行',
    },
    {
      prop: 'bankUnionNumber',
      label: '银行行号',
    },
  ];
};
